import {IPlatformService} from './IPlatformService';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BrowserService implements IPlatformService {
  get BrowserName(): string {
    let sBrowser;
    const sUsrAg = navigator.userAgent;

// The order matters here, and this may report false positives for unlisted browsers.

    if (sUsrAg.indexOf('Firefox') > -1) {
      sBrowser = 'Mozilla Firefox';
      // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
    } else if (sUsrAg.indexOf('SamsungBrowser') > -1) {
      sBrowser = 'Samsung Internet';
      // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
    } else if (sUsrAg.indexOf('Opera') > -1 || sUsrAg.indexOf('OPR') > -1) {
      sBrowser = 'Opera';
      // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
    } else if (sUsrAg.indexOf('Trident') > -1) {
      sBrowser = 'Microsoft Internet Explorer';
      // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
    } else if (sUsrAg.indexOf('Edge') > -1) {
      sBrowser = 'Microsoft Edge (Legacy)';
      // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
    } else if (sUsrAg.indexOf('Edg') > -1) {
      sBrowser = 'Microsoft Edge (Chromium)';
      // Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.124 Safari/537.36 Edg/91.0.864.64
    } else if (sUsrAg.indexOf('Chrome') > -1) {
      sBrowser = 'Google Chrome or Chromium';
      // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
    } else if (sUsrAg.indexOf('Safari') > -1) {
      sBrowser = 'Apple Safari';
      // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
    } else {
      sBrowser = 'unknown';
    }

    return sBrowser;
  }

  closeApp(): void {
  }

  get isAndroid(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('android') > -1;
  }

  get isArm(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('arm') > -1;
  }

  get isBrowser(): boolean {
    return true;
  }

  get isElectronApp(): boolean {
    return false;
  }

  get isIOS(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ||
      navigator.userAgent.toLowerCase().indexOf('ipad') > -1 ||
      navigator.userAgent.toLowerCase().indexOf('ipod') > -1 ||
      navigator.userAgent.toLowerCase().indexOf('ios') > -1;
  }

  get isLinux(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('linux') > -1;
  }

  get isMac(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('mac') > -1;
  }

  get isWindows(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('win') > -1;
  }

  get isX64(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('x64') > -1;
  }

  get isX86(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('x86') > -1;
  }

  get isHeadless(): Promise<boolean> {
    return Promise.resolve(window.parent !== window);
  }

  get isMainWindow(): Promise<boolean> {
    return Promise.resolve(window.opener === null);
  }

  maximizeApp(): void {
  }

  minimizeApp(): void {
  }

  requestApplicationExit() {
  }

  openHeadlessWindow(url: string): void {
    window.open(url, '_blank', 'popup, width=1024, height=600');
  }

  saveObjectToJsonFile(object: object) {
  }

  openNewWindow(url: string): void {
    window.open(url, '_blank');
  }

  openInBrowser(url: string): void {
    window.open(url, '_blank');
  }

  reloadApp(): void {
    window.location.reload();
  }

  closeCurrentWindow(): void {
    window.close();
  }

}
